import React from "react";
import { I, T } from "services/lang/LanguageService";
import useTabId from "hooks/dashboard/useTabId";
import useDashboardStore from "store/dashboard-store";
import { ProgressSpinner } from "primereact/progressspinner";
import DashboardTabGroup from "./DashboardTabGroup";
import Reorder from "./reorder/Reorder";
import { ReorderType } from "./reorder/DraggableItem";

const DashboardTab = () => {
  const tabId = useTabId();
  const dashboard = useDashboardStore(state => state.dashboard);
  const getTab = useDashboardStore(state => state.getTab);
  const isGroupReorderEnabled = useDashboardStore(state => state.isGroupReorderEnabled);
  const setIsGroupReorderEnabled = useDashboardStore(state => state.setIsGroupReorderEnabled);
  const refreshKey = useDashboardStore(state => state.refreshKey);

  if (!dashboard) {
    return <ProgressSpinner />;
  }

  const currentTab = getTab(tabId);

  if (!currentTab) {
    return <div>{T("message.tab-not-found")}</div>;
  }
  
  document.title = `EA - ${I(currentTab.title)}`

  return (
    <div key={refreshKey}>
      <div>
        {currentTab.componentGroups?.map(group => (
          <DashboardTabGroup key={group.id} group={group} tabId={tabId} />
        ))}
      </div>
      {isGroupReorderEnabled && (
        <Reorder
          setReorderDialogVisibility={setIsGroupReorderEnabled}
          reorderDialogVisibility={isGroupReorderEnabled}
          reorderType={ReorderType.GROUPS}
          tabId={tabId}
        />
      )}
    </div>
  );
};

export default DashboardTab;
